
import React, { useEffect, useState } from 'react';
import { usePhemexLang } from '@/contexts/PhemexLangContext';
import { ChevronDown, Globe } from 'lucide-react';
import { Menu } from '@headlessui/react';

const LanguageSelector = () => {
  const { lang, setLang } = usePhemexLang();
  const [mounted, setMounted] = useState(false);
  
  // Languages with their display names
  const languages = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'pt', name: 'Português' },
    { code: 'ru', name: 'Русский' },
    { code: 'tr', name: 'Türkçe' },
    { code: 'de', name: 'Deutsch' }  // Add German to the language list
  ];
  
  // Prevent hydration issues
  useEffect(() => {
    setMounted(true);
  }, []);
  
  if (!mounted) return null;
  
  return (
    <div className="absolute top-4 right-4 z-20">
      <Menu as="div" className="relative inline-block text-left">
        <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-lg bg-black/40 backdrop-blur-md px-3 py-2 text-sm font-medium text-white hover:bg-black/60">
          <Globe className="w-5 h-5 mr-1" />
          {languages.find(l => l.code === lang)?.name || 'English'}
          <ChevronDown className="w-4 h-4 ml-1" />
        </Menu.Button>
        
        <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-black/90 backdrop-blur-lg border border-gray-800 shadow-lg">
          <div className="py-1">
            {languages.map((l) => (
              <Menu.Item key={l.code}>
                {() => (
                  <button
                    onClick={() => setLang(l.code as any)}
                    className={`block w-full text-left px-4 py-2 text-sm ${
                      lang === l.code 
                        ? 'text-blue-400 bg-gray-800/50' 
                        : 'text-gray-300 hover:bg-gray-800/30'
                    }`}
                  >
                    {l.name}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Menu>
    </div>
  );
};

export default LanguageSelector;

